import { inject, Pipe, PipeTransform } from '@angular/core';
import { EnergyInterfacesStore } from '../stores/energy-interfaces.store';

@Pipe({
  name: 'energyInterfaceLabel',
})
export class EnergyInterfaceLabelPipe implements PipeTransform {
  private store = inject(EnergyInterfacesStore);

  transform(energyInterfaceID: string): string {
    const energyInterface = this.store
      .energyInterfaces()
      ?.find((ei) => ei.id === energyInterfaceID);
    return `${energyInterface?.data?.label || '-'}`;
  }
}
